export default __webpack_public_path__ + "static/media/delectable_logo.f24a150a.png";